import { CALL_API } from '../../../middleware/api';
import { apiEvents } from '../constants';
export const getDefaultPaymentsAccount = () => ({
    [CALL_API]: {
        endpoint: `/payments/default-account`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.paymentDefaultAccount,
    },
});
export const setDefaultPaymentsAccount = ({ id: accountId }) => ({
    [CALL_API]: {
        endpoint: `/payments/default-account`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ accountId }),
        types: apiEvents.paymentDefaultAccount,
    },
});
export const getCompletedPayments = (page, perPage, paymentRequestId, counterpartyHandle) => {
    let endpoint = `/payments/activity/completed?page=${page}&perPage=${perPage}`;
    if (paymentRequestId) {
        endpoint += `&paymentRequestId=${paymentRequestId}`;
    }
    if (counterpartyHandle) {
        endpoint += `&counterpartyHandle=${counterpartyHandle}`;
    }
    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: apiEvents.completedPayments,
        },
    };
};
export const getPendingPayments = () => ({
    [CALL_API]: {
        endpoint: '/payments/activity/pending',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.pendingPayments,
    },
});
export const getPendingPaymentsByHandle = (counterpartyHandle) => ({
    [CALL_API]: {
        endpoint: `/payments/activity/pending?counterpartyHandle=${counterpartyHandle}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: [
            'GET_PENDING_PAYMENTS_BY_HANDLE_REQUEST',
            'GET_PENDING_PAYMENTS_BY_HANDLE_SUCCESS',
            'GET_PENDING_PAYMENTS_BY_HANDLE_FAILURE',
        ],
    },
});
export const getPaymentInfo = (paymentId) => ({
    [CALL_API]: {
        endpoint: `/payments/${paymentId}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.paymentInfo,
    },
});
export const getPaymentRequestLink = (accountId, message, amount, payerUserHandles, payerPhoneNumbers, payerNicknames) => ({
    [CALL_API]: {
        endpoint: `/payment-requests`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            accountId,
            message,
            amount,
            currency: 'GBP',
            payerUserHandles,
            payerPhoneNumbers,
            payerNicknames,
            expiresAt: null,
        }),
        types: apiEvents.paymentLink,
    },
});
export const createPaymentRequests = ({ message, payerUserHandles, payerNicknames, amountsByPayers, originalTransactionId, }) => ({
    [CALL_API]: {
        endpoint: `/payment-requests`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message,
            payerUserHandles,
            payerNicknames,
            currency: 'GBP', // anyways bill sharing flow converts all currencies into GBP
            amountsByPayers,
            originalTransactionId,
        }),
        types: apiEvents.paymentLinksByNamesAndHandles,
    },
});
export const updatePaymentRequest = (id, amount) => ({
    [CALL_API]: {
        endpoint: `/payment-requests/${id}`,
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount }),
        types: apiEvents.updateBillSharingForTransaction,
    },
});
export const deleteBillSharingForTransaction = (originalTransactionId) => ({
    [CALL_API]: {
        endpoint: `/payment-requests`,
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            originalTransactionId,
        }),
        types: apiEvents.deleteBillSharingForTransaction,
    },
});
export const getPaymentRequestInfo = (token) => ({
    [CALL_API]: {
        endpoint: `/payment-requests/${token}/public-info`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.paymentRequestInfo,
    },
});
export const sendPayment = (sendFromAccountId, bankId, payeeUserHandle, amount, reference, payeeAccountId, onPaymentMadeCallback) => ({
    [CALL_API]: {
        endpoint: `/payments`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sendFromAccountId,
            bankId,
            payeeUserHandle,
            payeeAccountId,
            amount,
            currency: 'GBP',
            reference,
            onPaymentMadeCallback,
        }),
        types: apiEvents.paymentSend,
    },
});
export const fulfillPaymentRequest = (token, sendFromAccountId, bankId, amount, reference) => ({
    [CALL_API]: {
        endpoint: `/payment-requests/${token}/make-payment`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sendFromAccountId,
            bankId,
            amount,
            currency: 'GBP',
            reference,
        }),
        types: apiEvents.paymentRequestFulfill,
        reuseXRequestIdOnRetry: true,
    },
});
export const cancelPaymentRequest = (id) => ({
    [CALL_API]: {
        endpoint: `/payment-requests/${id}/invalidate`,
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.paymentRequestCancel,
    },
});
export const rejectPaymentRequest = (token) => ({
    [CALL_API]: {
        endpoint: `/payment-requests/${token}/reject`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.paymentRequestCancel,
    },
});
export const getHandleInfo = (handle) => ({
    [CALL_API]: {
        endpoint: `/user-handle/${handle}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: apiEvents.handleInfo,
    },
});
export const sendInternalPayment = (sendFromAccountId, sendToAccountId, amount, reference) => ({
    [CALL_API]: {
        endpoint: `/payments/internal`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sendFromAccountId,
            sendToAccountId,
            amount,
            currency: 'GBP',
            reference,
        }),
        types: apiEvents.paymentSend,
        reuseXRequestIdOnRetry: true,
    },
});
export const sendPaymentToBeneficiary = (sendFromAccountId, beneficiaryId, amount, reference) => ({
    [CALL_API]: {
        endpoint: `/payments/beneficiary`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sendFromAccountId,
            beneficiaryId,
            amount,
            currency: 'GBP',
            reference,
        }),
        types: apiEvents.paymentSend,
    },
});
export const sendPaymentThanks = (paymentId) => ({
    [CALL_API]: {
        endpoint: `/payments/${paymentId}/send-thank-you`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: apiEvents.paymentSendThanks,
    },
});
export const sendPaymentToTradingAccount = ({ amount, accountId, reference, }) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/deposit-link',
        method: 'POST',
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            accountId,
            reference: reference ?? 'EMMA TRADING',
        }),
        types: apiEvents.paymentSend,
    },
});
export const topUpGIAAccountFromBankAccount = ({ amount, tradingAccountId, bankAccountId, }) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/accounts/${tradingAccountId}/deposit-link`,
        method: 'POST',
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            bankAccountId,
        }),
        types: apiEvents.topUpGIAAccountFromBankAccount,
    },
});
export const topUpSecclAccountFromBankAccountUsingDirectDebit = ({ amount, tradingAccountId, }) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/accounts/${tradingAccountId}/direct-debit-deposit`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
        }),
        types: apiEvents.topUpSecclAccountFromBankAccountUsingDirectDebit,
    },
});
/**
 * the following function is used to deposit and buy asset using connected account using OB
 * since it uses OB, we get the deposit link and we should handle it
 */
export const buySecclAssetFromConnectedAccount = ({ pin, amount, assetId, accountId, fundOrderWithOpenBanking, fundOrderWithDirectDebit, }) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/orders',
        method: 'POST',
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            assetId,
            accountId,
            operation: 'buy',
            type: 'market',
            fundOrderWithOpenBanking,
            fundOrderWithDirectDebit,
        }),
        types: apiEvents.buySecclAssetFromConnectedAccount,
        pin,
        scope: 'order:write',
        reuseXRequestIdOnRetry: true,
    },
});
export const depositToPotFromBankAccountOrConnectedAccount = ({ potId, amount, accountId, }) => ({
    [CALL_API]: {
        endpoint: `/wealth/pots/${potId}/deposit-from-bank`,
        method: 'POST',
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            ...(accountId && { accountId }),
        }),
        types: apiEvents.depositToPotFromBankAccountOrConnectedAccount,
    },
});
